export default function() {
  return [
    {
      title: "Home",
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      to: "/home",
    },
    {
      title: "Efectores",
      htmlBefore: '<i class="material-icons">table_chart</i>',
      to: "/efectores",
    },
    {
      title: "Notificaciones",
      htmlBefore: '<i class="material-icons">&#xE7F4;</i>',
      to: "/notifications",
    }
  ];
}
